/* eyeRlaxPRO — efectos de scroll con GSAP + ScrollTrigger.
   Zoom suave de imágenes dentro de marcos + parallax vertical sutil.
   Respeta prefers-reduced-motion y no toca el comparador antes/después. */
(function () {
  var prefiereMenos = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefiereMenos) return;

  function iniciar() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
    gsap.registerPlugin(ScrollTrigger);

    // 1) Zoom suave dentro de marcos que ya recortan (overflow hidden):
    //    pasos de "cómo se usa" e imagen principal del producto.
    var marcos = document.querySelectorAll('.elx-usar-imagen-wrap, .elx-producto-imagen-principal, [data-elx-zoom]');
    marcos.forEach(function (marco) {
      var img = marco.querySelector('img');
      if (!img) return;
      marco.style.overflow = 'hidden';
      gsap.fromTo(img,
        { scale: 1.0 },
        {
          scale: 1.14,
          ease: 'none',
          scrollTrigger: { trigger: marco, start: 'top 88%', end: 'bottom 12%', scrub: 0.6 }
        }
      );
    });

    // 2) Banner superior de portada (sección de Dawn): zoom lento al hacer scroll.
    document.querySelectorAll('.banner__media img').forEach(function (img) {
      var marco = img.closest('.banner__media');
      if (marco) marco.style.overflow = 'hidden';
      gsap.fromTo(img,
        { scale: 1.0 },
        {
          scale: 1.12,
          ease: 'none',
          scrollTrigger: { trigger: marco || img, start: 'top top', end: 'bottom top', scrub: 0.6 }
        }
      );
    });

    // 3) Parallax vertical sutil en la imagen del hero (se mueve un poco más lento).
    document.querySelectorAll('.elx-hero-imagen').forEach(function (img) {
      gsap.fromTo(img,
        { yPercent: -5 },
        {
          yPercent: 5,
          ease: 'none',
          scrollTrigger: { trigger: img, start: 'top bottom', end: 'bottom top', scrub: 0.6 }
        }
      );
    });

    ScrollTrigger.refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
  // Recalcular medidas cuando ya han cargado las imágenes (evita saltos).
  window.addEventListener('load', function () {
    if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
  });
})();
